import { _ as __vue_normalize__ } from './chunk-cca88db8.js'; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: 'BTag',
  props: {
    attached: Boolean,
    closable: Boolean,
    type: String,
    size: String,
    rounded: Boolean,
    disabled: Boolean,
    ellipsis: Boolean,
    tabstop: {
      type: Boolean,
      "default": true
    },
    ariaCloseLabel: String,
    closeType: String,
    closeIcon: String,
    closeIconPack: String,
    closeIconType: String
  },
  methods: {
    /**
    * Emit close event when delete button is clicked
    * or delete key is pressed.
    */
    close: function close(event) {
      if (this.disabled) return;
      this.$emit('close', event);
    }
  }
};
/* script */

var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.attached && _vm.closable ? _c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag",
    "class": [_vm.type, _vm.size, {
      'is-rounded': _vm.rounded
    }]
  }, [_c('span', {
    "class": {
      'has-ellipsis': _vm.ellipsis
    }
  }, [_vm._t("default")], 2)]), _c('a', {
    staticClass: "tag",
    "class": [_vm.size, _vm.closeType, {
      'is-rounded': _vm.rounded
    }, _vm.closeIcon ? 'has-delete-icon' : 'is-delete'],
    attrs: {
      "role": "button",
      "aria-label": _vm.ariaCloseLabel,
      "tabindex": _vm.tabstop ? 0 : false,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.close,
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) {
          return null;
        }

        $event.preventDefault();
        return _vm.close($event);
      }
    }
  }, [_vm.closeIcon ? _c('b-icon', {
    attrs: {
      "custom-class": "",
      "icon": _vm.closeIcon,
      "size": _vm.size,
      "type": _vm.closeIconType,
      "pack": _vm.closeIconPack
    }
  }) : _vm._e(), _c('a')], 1)]) : _c('span', {
    staticClass: "tag",
    "class": [_vm.type, _vm.size, {
      'is-rounded': _vm.rounded
    }]
  }, [_c('span', {
    "class": {
      'has-ellipsis': _vm.ellipsis
    }
  }, [_vm._t("default")], 2), _vm.closable ? _c('a', {
    staticClass: "delete is-small",
    "class": _vm.closeType,
    attrs: {
      "role": "button",
      "aria-label": _vm.ariaCloseLabel,
      "disabled": _vm.disabled,
      "tabindex": _vm.tabstop ? 0 : false
    },
    on: {
      "click": _vm.close,
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) {
          return null;
        }

        $event.preventDefault();
        return _vm.close($event);
      }
    }
  }) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

var Tag = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

export { Tag as T };